import EmbassyDocumentHistory from "./EmbassyDocumentHistory.component.jsx";

export default EmbassyDocumentHistory;